import URLs from "../utils/Urls";
import api from "../api/api";
import axios from "axios";

let headers = {
  "Content-Type": "application/json",
};
const config = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

const config2 = {
  headers: {
    "Content-Type": "multipart/form-data",
    "Content-Type": "application/json",
  },
};

export default {
  login: (data) =>
    api.post(URLs.login, data, { headers: headers }).then((response) => {
      return response;
    }),
  authoriseAutoLoginUser: (data) =>
    api.get(URLs.authoriseAutoLoginUser + data).then((response) => {
      return response.data;
    }),
  change_password: (data) =>
    api.post(URLs.change_password, data).then((response) => {
      return response;
    }),
  forgot_password: {
    send_otp: (data) =>
      api.post(URLs.send_otp, data).then((response) => {
        return response;
      }),
    verify_otp: (data) =>
      api.post(URLs.verify_otp, data).then((response) => {
        return response;
      }),
    reset_password: (data) =>
      api.post(URLs.reset_password, data).then((response) => {
        return response;
      }),
  },

  demographics: {
    get: (data) =>
      api.get(URLs.get_demographics + data).then((response) => {
        return response.data;
      }),
    get_percentage: (data) =>
      api.get(URLs.get_demographic_percentage + data).then((response) => {
        return response.data;
      }),
    save: (data) =>
      api.post(URLs.save_demographics, data).then((response) => {
        return response;
      }),

    ecas_study: {
      get: (data) =>
        api.get(URLs.get_ecas_study_demographics + data).then((response) => {
          return response.data;
        }),
      get_percentage: (data) =>
        api
          .get(URLs.get_ecas_study_demographic_percentage + data)
          .then((response) => {
            return response.data;
          }),
      save: (data) =>
        api.post(URLs.save_ecas_study_demographics, data).then((response) => {
          return response;
        }),
    },
    speech: {
      get: (data) =>
        api.get(URLs.get_speech_study_demographics + data).then((response) => {
          return response.data;
        }),
      save: (data) =>
        api.post(URLs.save_speech_study_demographics, data).then((response) => {
          return response;
        }),
      check_als_user: (params) =>
        api
          .get(URLs.check_speech_study_demographics_als_user + params)
          .then((response) => {
            return response.data;
          }),
    },
    le_study: {
      get: (data) =>
        api.get(URLs.get_le_study_demographics + data).then((response) => {
          return response.data;
        }),
      save: (data) =>
        api.post(URLs.save_le_study_demographics, data).then((response) => {
          return response;
        }),
      get_percentage: (data) =>
        api
          .get(URLs.get_le_study_demographic_percentage + data)
          .then((response) => {
            return response.data;
          }),
    },
  },
  eals_frs: {
    get: (data) =>
      api.get(URLs.get_ealsfrs_lists + data).then((response) => {
        return response.data;
      }),
    save: (data) =>
      api.post(URLs.save_ealsfrs, data).then((response) => {
        return response;
      }),
  },
  ares_score: {
    get: (data) =>
      api.get(URLs.get_ares_score_lists + data).then((response) => {
        return response.data;
      }),
    save: (data) =>
      api.post(URLs.save_ares_score, data).then((response) => {
        return response;
      }),
  },
  cpib_form: {
    get: (data) =>
      api.get(URLs.get_cpib_form_list + data).then((response) => {
        return response.data;
      }),
    save: (data) =>
      api.post(URLs.save_cpib_form, data).then((response) => {
        return response;
      }),
  },
  roads: {
    get: (data) =>
      api.get(URLs.get_road_list + data).then((response) => {
        return response.data;
      }),
    save: (data) =>
      api.post(URLs.save_road_session, data).then((response) => {
        return response;
      }),
  },
  ecas: {
    get: (data) =>
      api.get(URLs.get_ecas_form_list + data).then((response) => {
        return response.data;
      }),
    view_ecas: (data) =>
      api.get(URLs.get_ecas_form_details + data).then((response) => {
        return response.data;
      }),
  },
  consent_form: {
    get: (data) =>
      api.get(URLs.check_consent_form_status + data).then((response) => {
        return response.data;
      }),
    speech: {
      check_consent_form_status: (data) =>
        api
          .get(URLs.check_speech_consent_form_status + data)
          .then((response) => {
            return response.data;
          }),
    },
  },
  genetic_confirmation_document: {
    get: (data) =>
      api
        .get(URLs.get_genetic_confirmation_document + data)
        .then((response) => {
          return response.data;
        }),
    upload: (data) =>
      api
        .post(URLs.upload_pdf_for_genetic_confirmation, data, config)
        .then((response) => {
          return response.data;
        }),
    view_pdf: (data) =>
      api
        .get(URLs.view_genetic_confirmation_document + data)
        .then((response) => {
          return response.data;
        }),
    rename: (data) =>
      api
        .post(URLs.rename_genetic_confirmation_document, data, {
          headers: headers,
        })
        .then((response) => {
          return response.data;
        }),
    remove_pdf: (data) =>
      api
        .get(URLs.remove_genetic_confirmation_document + data)
        .then((response) => {
          return response.data;
        }),
  },
  personal_data_viewer: {
    get_start_speech_session_link: (data) =>
      api.get(URLs.get_start_speech_session_link + data).then((response) => {
        return response.data;
      }),
    get_asymptomatic_client_code: (data) =>
      api.get(URLs.get_asymptomatic_client_code + data).then((response) => {
        return response.data;
      }),
    get_proctored_session_details: (data) =>
      api.get(URLs.get_proctored_session_details + data).then((response) => {
        return response.data;
      }),
    get_actigraph_session_log_list: (data) =>
      api.get(URLs.get_actigraph_session_log_list + data).then((response) => {
        return response.data;
      }),
    get_actigraph_list: (data) =>
      api.get(URLs.get_actigraph_list + data).then((response) => {
        return response.data;
      }),

    // patient portal apis
    get_session_data: (params) =>
      axios.get(URLs.get_report_data + params).then((response) => {
        return response;
      }),
    get_alsfrs_breakdown: (params) =>
      axios.get(URLs.get_report_data + params).then((response) => {
        return response;
      }),
    get_roads_breakdown: (params) =>
      axios.get(URLs.get_report_data + params).then((response) => {
        return response;
      }),
    get_key_statistics: (params) =>
      axios.get(URLs.get_report_data + params).then((response) => {
        return response;
      }),
    get_chart_category_list: (params) =>
      axios.get(URLs.get_chart_category_list + params).then((response) => {
        return response;
      }),
    get_datadownload_list: (params) =>
      axios.get(URLs.get_report_data + params).then((response) => {
        return response;
      }),
    get_speech_file_url: (data) =>
      api.post(URLs.get_speech_file_url, data, { headers }).then((response) => {
        return response.data;
      }),
    get_notes_data: (params) =>
      axios.get(URLs.get_notes_data + params).then((response) => {
        return response;
      }),
    get_chart_one_data: (params) =>
      axios.get(URLs.get_report_data + params).then((response) => {
        return response;
      }),
    get_chart_two_data: (params) =>
      axios.get(URLs.get_report_data + params).then((response) => {
        return response;
      }),

    ecas_study: {
      get_physical_ecas_form: (params) =>
        api.get(URLs.get_physical_ecas_form_list + params).then((response) => {
          return response;
        }),
      save_physical_ecas_form: (params) =>
        api
          .post(URLs.save_physical_ecas_form, params, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            return response;
          }),
      get_ecas_form_list: (params) =>
        api.get(URLs.get_physical_ecas_form_list + params).then((response) => {
          return response.data;
        }),
      get_physical_ecas_form_url: (params) =>
        api.post(URLs.get_physical_ecas_form_url, params).then((response) => {
          return response.data;
        }),
      save_ecas_study_alsfrsr_upload_form: (params) =>
        api.post(URLs.save_ecas_study_alsfrsr_upload_form, params, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then((response) => {
          return response.data;
        }),
      get_physical_ecas_study_alsfrsr_form_url: (params) =>
        api.post(URLs.get_physical_ecas_study_alsfrsr_form_url, params).then((response) => {
          return response.data;
        }),
      get_new_ecas_live_session: (params) =>
        api.get(URLs.get_new_ecas_live_session + params).then((response) => {
          return response.data;
        }),
    },
    speech: {
      get_speech_client_code: (params) =>
        api.get(URLs.get_speech_client_code + params).then((response) => {
          return response.data;
        }),
    },
    le_study:{
      get_le_study_session_list: (params) =>
        api
          .get(URLs.get_le_study_session_list + params)
          .then((response) => {
            return response.data;
          }),
      get_le_study_eals_frs_score: (params) =>
        api
          .get(URLs.get_le_study_eals_frs_score + params)
          .then((response) => {
            return response.data;
          }),
      get_le_study_inclinic_alsfrs_score: (params) =>
        api
          .get(URLs.get_le_study_inclinic_alsfrs_score + params)
          .then((response) => {
            return response.data;
          }),
      get_pgi_list: (params) =>
        api.get(URLs.get_le_study_pgi_list + params).then((response) => {
          return response.data;
        }),
      get_pgi_graph: (params) =>
        api.get(URLs.get_le_study_pgi_graph + params).then((response) => {
          return response.data;
        }),
      get_le_study_in_clinic_session_list: (params) =>
        api
          .get(URLs.get_le_study_in_clinic_session_list + params)
          .then((response) => {
            return response.data;
          }),
    }
  },

  get_ecas_form_details_for_app_page: (params) =>
    axios
      .get(URLs.get_ecas_form_details_for_app_page + params)
      .then((response) => {
        return response.data;
      }),

  participants: {
    speech: {
      save_participant: (params) =>
        api.post(URLs.add_new_speech_participant, params).then((response) => {
          return response.data;
        }),
      generate_neurostamp_id: (params) =>
        api.post(URLs.generate_neurostamp_id, params).then((response) => {
          return response.data;
        }),
      get_voice_recording_details: (params) =>
        api.get(URLs.get_voice_recording_details + params).then((response) => {
          return response.data;
        }),
      save_voice_recording: (params) =>
        api.post(URLs.save_voice_recording, params).then((response) => {
          return response.data;
        }),
      get_available_accounts: (params) =>
        api.get(URLs.get_available_accounts + params).then((response) => {
          return response.data;
        }),
      alsfrs: {
        list: (params) =>
          api.get(URLs.get_alsfrs_question_list + params).then((response) => {
            return response.data;
          }),
        save_alsfrs: (params) =>
          api.post(URLs.save_speech_alsfrs, params).then((response) => {
            return response.data;
          }),
      },
      roads: {
        save_roads: (params) =>
          api.post(URLs.save_speech_roads, params).then((response) => {
            return response.data;
          }),
      },
      session: {
        start: (params) =>
          api.post(URLs.start_speech_session, params).then((response) => {
            return response.data;
          }),
        getSentences: (params) =>
          api
            .get(URLs.get_speech_session_sentences + params)
            .then((response) => {
              return response.data;
            }),
        getPicture: (params) =>
          api.get(URLs.get_speech_session_picture + params).then((response) => {
            return response.data;
          }),
        save: (params) =>
          api.post(URLs.save_speech_session, params).then((response) => {
            return response.data;
          }),
        updateAudiodb: (params) =>
          api
            .post(URLs.update_speech_session_audiodb, params)
            .then((response) => {
              return response.data;
            }),
        submitPgiScore: (params) =>
          api
            .post(URLs.submit_speech_session_pgi_score, params)
            .then((response) => {
              return response.data;
            }),
        end: (params) =>
          api.post(URLs.end_speech_session, params).then((response) => {
            return response.data;
          }),
        abandon: (params) =>
          api.post(URLs.abandon_speech_session, params).then((response) => {
            return response.data;
          }),
      },
    },
    ecas_study: {
      save_participant: (params) =>
        api.post(URLs.add_new_ecas_participant, params).then((response) => {
          return response.data;
        }),
      get_participant_date_created: (params) =>
        api
          .get(URLs.get_ecas_study_participant_date_created + params)
          .then((response) => {
            return response.data;
          }),
      save_alsfrsr_score: (params) =>
        api.post(URLs.save_ecas_study_alsfrsr, params).then((response) => {
          return response.data;
        }),
      get_ecas_study_alsfrsr_score: (params) =>
        api.get(URLs.get_ecas_study_alsfrsr_score_list + params).then((response) => {
          return response.data;
        }),
    },
    le_study: {
      get_le_study_language: (params) =>
        api.get(URLs.get_le_study_language + params).then((response) => {
          return response.data;
        }),
      save_participant: (params) =>
        api.post(URLs.add_new_le_study_participant, params).then((response) => {
          return response.data;
        }),
      get_participant_details: (params) =>
        api
          .get(URLs.get_le_study_participant_details + params)
          .then((response) => {
            return response.data;
          }),
    },
  },

  profile: {
    getProfileDetails: (params) =>
      api.post(URLs.get_profile_details, params).then((response) => {
        return response.data;
      }),
    updateProfileDetails: (data) =>
      api.post(URLs.update_profile_details, data).then((response) => {
        return response.data;
      }),
  },

  get_ecas_user_type: (data) =>
    api.get(URLs.get_ecas_user_type + data).then((response) => {
      return response.data;
    }),
};
